export default __webpack_public_path__ + "static/media/arrow-green-l.f80cbe6b.svg";